import * as React from "react";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import { v4 as uuid } from "uuid";

interface IPositionedMenuProps {
	buttonTitle: string;
	children?: JSX.Element[];
}

export const PositionedMenu: React.FC<IPositionedMenuProps> = (props) => {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};
	const handleClose = () => {
		setAnchorEl(null);
	};
	const randomGuid = uuid();

	return (
		<div>
			<Button
				id={`${randomGuid}-positioned-button`}
				aria-controls={open ? `${randomGuid}-positioned-button` : undefined}
				aria-haspopup="true"
				aria-expanded={open ? "true" : undefined}
				onClick={handleClick}
			>
				{props.buttonTitle}
			</Button>
			<Menu
				id={`${randomGuid}-positioned-menu`}
				aria-labelledby={`${randomGuid}-positioned-button`}
				anchorEl={anchorEl}
				open={open}
				onClose={handleClose}
				anchorOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
				transformOrigin={{
					vertical: "top",
					horizontal: "left",
				}}
			>
				{props.children}
			</Menu>
		</div>
	);
};
